import {
  Box,
  Breadcrumbs,
  Button,
  FormLabel,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card } from "../../ui/Card";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import { StyledInput } from "../../ui/StyledInput";
import { useEffect, useState } from "react";
import {
  addCompanyDetail,
  fetchCompanyDetail,
  updateCompanyDetail,
} from "../../../config/api";
import toast from "react-hot-toast";
import ProfilePic from "../../../assests/profile.jpg";
import Title from "../../ui/Title";
import { StyledSeperator } from "../../ui/Seperator";
import { Padding } from "@mui/icons-material";
import { StyledButton } from "../../ui/StyledButton";

interface FormData {
  company_name: string;
  company_url: string;
  company_email: string;
  company_logo_image: File | undefined;
}

const CompanyProfile = () => {
  const location = useLocation();
  const [isData, setIsData] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const [isError, setIsError] = useState({ email: "" });
  const navigate = useNavigate();

  const [formData, setFormData] = useState<FormData>({
    company_name: "",
    company_url: "",
    company_email: "",
    company_logo_image: undefined,
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files;
    let image = (file && file.length > 0 && file[0]) || undefined;
    setFormData({ ...formData, company_logo_image: image });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { company_name, company_url, company_email, company_logo_image } =
      formData;

    if (!validateForm(formData)) {
      if (!isData) {
        addCompanyDetail({
          company_name,
          company_url,
          company_email,
          company_logo_image,
        })
          .then((data) => {
            toast.success("Company Detail Add Succesfully!");
            navigate(location.state?.prevurl || "/");
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
      } else {
        updateCompanyDetail({
          company_name,
          company_url,
          company_email,
          company_logo_image: undefined,
        })
          .then((data) => {
            toast.success("Company Detail Update Succesfully!");
            navigate("/settings");
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
      }
    }
  };

  const validateForm = ({
    company_email: email,
  }: {
    company_email: string;
  }) => {
    let haveErros = false;

    let errors = {
      email: "",
    };

    if (!email) {
      errors.email = "Email is required";
      haveErros = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid";
      haveErros = true;
    }
    setIsError(errors);
    return haveErros;
  };

  useEffect(() => {
    fetchCompanyDetail()
      .then((data) => {
        if (data?.data?.data) {
          // console.log(data?.data?.data?.company_logo_image);

          setIsData(true);
          setFormData({
            company_name: data?.data?.data?.company_name,
            company_url: data?.data?.data?.company_url,
            company_email: data?.data?.data?.company_email,
            company_logo_image: data?.data?.data?.company_logo_image,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (
      formData.company_name == "" ||
      formData.company_url == "" ||
      formData.company_email == ""
    ) {
      setCanSubmit(false);
    } else {
      setCanSubmit(true);
    }
  }, [formData]);

  return (
    <>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/settings">
            <Typography color="text.primary" fontWeight={600}>
              Settings
            </Typography>
          </Link>
          <Typography color="text.primary">Company</Typography>
          <Typography color="text.primary">Company Profile</Typography>
        </Breadcrumbs>
      </Box>
      <Grid container rowGap={"20px"} columnGap={"20px"}>
        <Grid item md={12}>
          <Grid item md={7}>
            <Card>
              <Box
                sx={{
                  margin: "10px 0",
                }}
              >
                {/* <Grid container spacing={2} md={6} borderBottom="1px solid black">
            <Grid item xs={12} md={6}>
              <Title title="Company Details" />
            </Grid>
            <Grid item xs={12} md={6}>
              <div>
                <img
                  width={"100px"}
                  height={"100px"}
                  src={ProfilePic}
                  alt=""
                  draggable={false}
                />
              </div>
            </Grid>
          </Grid> */}

                <Box>
                  {/* <Grid
                    container
                    md={6}
                    justifyContent="space-between"
                    alignItems="center"
                  > */}
                    <Title title="Company Details" />
                    <StyledSeperator
                      style={{
                        margin: "10px",
                        width: "100%",
                      }}
                    />
                  {/* </Grid> */}

                  <form onSubmit={handleSubmit}>
                    <Grid container mt={2}>
                      <Grid item xs={12} md={9}>
                        <FormLabel>
                          <Typography fontSize={15}>Company Name</Typography>
                        </FormLabel>
                        <StyledInput
                          placeholder="Enter Company Name"
                          fullWidth
                          id="company_name"
                          name="company_name"
                          value={formData.company_name}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container mt={2}>
                      <Grid item xs={12} md={9}>
                        <FormLabel>
                          <Typography fontSize={15}>Website</Typography>
                        </FormLabel>
                        <StyledInput
                          placeholder="Enter Website"
                          fullWidth
                          id="company_url"
                          name="company_url"
                          value={formData.company_url}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container mt={2}>
                      <Grid item xs={12} md={9}>
                        <FormLabel>
                          <Typography fontSize={15}>Email</Typography>
                        </FormLabel>
                        <StyledInput
                          fullWidth
                          placeholder="Enter Email ID"
                          id="company_email"
                          name="company_email"
                          value={formData.company_email}
                          onChange={handleInputChange}
                          error={Boolean(isError.email)}
                          focused={Boolean(isError.email)}
                          helperText={isError.email && isError.email}
                        />
                      </Grid>
                    </Grid>
                    <Grid container mt={2}>
                      <Grid item xs={12} md={12}>
                        <FormLabel>
                          <Typography fontSize={15}>Website/Company Logo</Typography>
                        </FormLabel>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        mt={1}
                        md={9}
                        p={2}
                        border={"1px solid black"}
                      >
                        <TextField
                          type="file"
                          id="company_logo_image"
                          name="company_logo_image"
                          onChange={handleFileInputChange}
                          fullWidth
                        />

                        {isData && (
                          <div>
                            <img
                              width={"100px"}
                              height={"100px"}
                              src={
                                "https://cdn.pixabay.com/photo/2016/11/21/22/09/white-male-1847735_1280.jpg"
                              }
                              // src={"https://storage.cloud.google.com/hipship_test/comapny_logo_image/delhivery_logo_1.png"}
                              // value={formData.company_email}
                              alt=""
                              draggable={false}
                            />
                          </div>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container mt={3}>
                      <Grid item xs={12} md={9}>
                        {(!isData && (
                          <StyledButton
                            type="submit"
                            variant="contained"
                            fullWidth
                            disabled={!canSubmit}
                          >
                            Save
                          </StyledButton>
                        )) || (
                            <StyledButton
                              type="submit"
                              variant="contained"
                              fullWidth
                              disabled={!canSubmit}
                            >
                              Update
                            </StyledButton>
                          )}
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const StyledSubTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 23px;
`;

export default CompanyProfile;
